/* eslint-disable react-refresh/only-export-components */

import type { FC, ReactNode } from "react";

import { t } from "i18n/i18n";
import {
  ChatWithLinesIcon,
  CircleQuestionIcon,
  ClipboardPenIcon,
  ContactsIcon,
  HatGlassesIcon,
  InstructorNotesIcon,
  PageListIcon,
  PaperClipLinkIcon,
  PersonClassIcon,
  PersonSingleIcon,
  RobotAIIcon,
} from "mds/icons";
import { CONTENT_SIDEBAR_TAB_NAME } from "utils/urls";

export const SIDEBAR_PANEL_ICONS: Record<CONTENT_SIDEBAR_TAB_NAME, FC> = {
  Topics: PageListIcon,
  Assignment: ClipboardPenIcon,
  CourseResource: PaperClipLinkIcon,
  InstructorWorkspace: HatGlassesIcon,
  Planner: ContactsIcon,
  InstructorNotes: InstructorNotesIcon,
  AiAssistant: RobotAIIcon,
  Users: PersonClassIcon,
  Profile: PersonSingleIcon,
  HelpCenter: CircleQuestionIcon,
  ClassChat: ChatWithLinesIcon,
};

// This is only used for the Amplitude event names.
export const TAB_EVENT_NAMES: Record<CONTENT_SIDEBAR_TAB_NAME, string> = {
  Topics: "Sidebar - Topics",
  Planner: "Sidebar - Planner",
  InstructorNotes: "Sidebar - Notes",
  AiAssistant: "Sidebar - AI assistant",
  Users: "Sidebar - Users",
  Profile: "Sidebar - Profile",
  HelpCenter: "Sidebar - Help center",
  Assignment: "Sidebar - Assignment",
  CourseResource: "Sidebar - Course resource",
  InstructorWorkspace: "Sidebar - Instructor workspace",
  ClassChat: "Sidebar - Class chat",
};

// These log names can be enforced in Typescript later.
export const SIDEBAR_EXPAND_EVENT_NAME = "Sidebar - Expand";
export const SIDEBAR_COLLAPSE_EVENT_NAME = "Sidebar - Collapse";

export const TabKeys = Object.keys(SIDEBAR_PANEL_ICONS);

export type TabProps = {
  [Tab in CONTENT_SIDEBAR_TAB_NAME as `${Tab}Panel`]?: ReactNode;
};

export const getSidebarHeaderText = (tab: CONTENT_SIDEBAR_TAB_NAME) =>
  t(`content_sidebar.title.${tab}`);

export const getSidebarHeader = (tab: CONTENT_SIDEBAR_TAB_NAME) => (
  <h3 className="mb-0 text-black-tint-20">{getSidebarHeaderText(tab)}</h3>
);
